<template>
  <div class="py-2">
    <div
      class="h-2 w-full rounded-xl relative"
      :style="`background: linear-gradient(to right, ${successColor} ${progress}%, ${successColor} ${progress}%, ${blankColor} 0)
      no-repeat;`"
    >
      <template v-if="showLabel">
        <span
          class="absolute text-white left-0 top-3 text-xs font-semibold"
        >{{ $filters.formatMoney(0) }}</span>
        <span
          class="absolute text-white right-0 top-3 text-xs font-semibold"
        >{{ $filters.formatMoney(upperLimit) }}</span>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ApprovedLimit',
  props: {
    upperLimit: {
      type: Number,
      required: true,
    },
    currentLimit: {
      type: Number,
      required: true,
    },
    successColor: {
      type: String,
      default: '#00b8ce',
    },
    blankColor: {
      type: String,
      default: '#006f90',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    progress() {
      return (this.currentLimit / this.upperLimit) * 100;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
